export const viewStyle={
    wrapper:{ width: "100%", maxWidth: "calc(100% - 10px)" },
    tableRow:{
        "& > *": { borderBottom: "unset" },
        "& < *": { borderBottom: "unset" },
      }
}